import { useEffect, useRef } from "react";
import { X } from "lucide-react";

const BottomSheet = ({ isOpen, onClose, title, subtitle, children, tall = false, zClass = "z-50" }) => {
  const sheetRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sheetRef.current && !sheetRef.current.contains(e.target)) onClose();
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 bg-black/50 ${zClass} flex items-end justify-center`}>
      <div
        ref={sheetRef}
        className={`bg-white w-full max-w-lg rounded-t-3xl ${tall ? "max-h-[92vh]" : "max-h-[85vh]"} overflow-y-auto animate-slide-up`}
      >
        {title ? (
          <div className="sticky top-0 bg-white z-10 px-5 pt-3 pb-4 border-b border-gray-100">
            <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-3" />
            <div className="flex justify-between items-start">
              <div>
                <h2 className="text-xl font-bold text-gray-800">{title}</h2>
                {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
              </div>
              <button
                onClick={onClose}
                aria-label="Close"
                className="w-11 h-11 -mr-2 -mt-1 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={20} className="text-gray-400" />
              </button>
            </div>
          </div>
        ) : (
          // No title: the content draws its own header (e.g. the Pro hero), so
          // only the drag handle and a floating close button sit on top of it.
          <div className="sticky top-0 z-10 h-0">
            <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mt-3 relative" />
            <button
              onClick={onClose}
              aria-label="Close"
              className="absolute right-3 top-3 w-11 h-11 flex items-center justify-center rounded-full bg-white/70 hover:bg-white transition-colors"
            >
              <X size={20} className="text-gray-500" />
            </button>
          </div>
        )}
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
};

export default BottomSheet;
